import { render, staticRenderFns } from "./BaseNavigation.vue?vue&type=template&id=5ad6874a&scoped=true"
import script from "./BaseNavigation.vue?vue&type=script&lang=js"
export * from "./BaseNavigation.vue?vue&type=script&lang=js"
import style0 from "./BaseNavigation.vue?vue&type=style&index=0&id=5ad6874a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad6874a",
  null
  
)

export default component.exports